module.exports = __webpack_public_path__ + "img/product43_img01.8ed7e878.png";